<div class="min-h-screen bg-[#F3F4F6] dark:bg-slate-900 p-4 md:p-8   text-slate-600 dark:text-slate-300" *ngIf="!isFormView">
    <!-- Header -->
    <div class="animate-fade-in flex flex-col md:flex-row md:items-end justify-between mb-8 gap-4">
        <div>
            <h1 class="text-3xl font-extrabold text-slate-800 dark:text-white tracking-tight">รายได้อื่นๆ (Revenues)
            </h1>
            <p class="text-slate-500 dark:text-slate-400 mt-2 font-medium">
                จัดการข้อมูลรายได้อื่นๆ ของระบบ —
                ลาน: <span class="font-bold text-amber-600">{{ siteState.selectedSite()?.name || 'กรุณาเลือกลาน' }}</span>
            </p>
        </div>
        <div class="flex items-center gap-3">
            <!-- Date Filter -->
            <div
                class="flex items-center gap-2 px-3 py-2 bg-slate-50 dark:bg-slate-800/50 rounded-xl border border-slate-50 dark:border-slate-700/50 focus-within:bg-white dark:focus-within:bg-slate-800 focus-within:ring-2 focus-within:ring-amber-200 transition-all shadow-sm h-[46px] w-full sm:w-auto">
                <span class="material-icons text-slate-400 dark:text-slate-500 text-xl">calendar_today</span>

                <div class="relative w-full sm:w-[130px] h-full flex items-center">
                    <div
                        class="absolute inset-0 flex items-center justify-between px-3 font-bold text-sm text-slate-600 dark:text-slate-300 pointer-events-none font-display">
                        <span>{{ startDate | date:'dd/MM/yyyy' }}</span>
                        <span class="material-icons text-slate-400 dark:text-slate-500 text-lg">expand_more</span>
                    </div>
                    <input #startDatePicker type="date" [(ngModel)]="startDate" (change)="onDateChange()"
                        [max]="endDate" (click)="startDatePicker.showPicker()"
                        class="opacity-0 w-full h-full cursor-pointer z-10 border-none p-0 focus:ring-0">
                </div>

                <span class="text-slate-300 dark:text-slate-600">-</span>

                <div class="relative w-full sm:w-[130px] h-full flex items-center">
                    <div
                        class="absolute inset-0 flex items-center justify-between px-3 font-bold text-sm text-slate-600 dark:text-slate-300 pointer-events-none font-display">
                        <span>{{ endDate | date:'dd/MM/yyyy' }}</span>
                        <span class="material-icons text-slate-400 dark:text-slate-500 text-lg">expand_more</span>
                    </div>
                    <input #endDatePicker type="date" [(ngModel)]="endDate" (change)="onDateChange()" [min]="startDate"
                        (click)="endDatePicker.showPicker()"
                        class="opacity-0 w-full h-full cursor-pointer z-10 border-none p-0 focus:ring-0">
                </div>
            </div>

            <button *ngIf="canCreate" (click)="navigateToCreate()"
                class="px-5 py-3 bg-amber-400 text-white rounded-xl shadow-lg shadow-amber-200 dark:shadow-amber-900/20 hover:bg-amber-500 hover:-translate-y-1 transition-all duration-300 font-bold flex items-center gap-2">
                <span class="material-icons">add_circle</span>
                <span>เพิ่มรายได้</span>
            </button>

            <button (click)="toggleDashboard()"
                class="hidden sm:flex px-4 py-3 bg-white dark:bg-slate-800 text-slate-500 dark:text-slate-400 rounded-xl shadow-sm border border-slate-200 dark:border-slate-700 hover:text-amber-500 dark:hover:text-amber-400 hover:shadow-md transition-all active:scale-95 items-center gap-2"
                [title]="showDashboard ? 'ซ่อนกราฟ' : 'แสดงกราฟ'">
                <span class="material-icons">{{ showDashboard ? 'visibility_off' : 'visibility' }}</span>
                <span class="text-sm font-bold">{{ showDashboard ? 'ซ่อนกราฟ' : 'แสดงกราฟ' }}</span>
            </button>

            <div *ngIf="lastFetchedTime" class="flex flex-col items-end text-right">
                <span class="text-[11px] text-slate-400 dark:text-slate-500 font-medium leading-none mb-1">ดึงข้อมูลล่าสุด</span>
                <span class="text-[13px] font-bold text-slate-600 dark:text-slate-400 leading-none">{{ lastFetchedTime | date:'HH:mm:ss' }}</span>
            </div>
            <button (click)="onRefresh()"
                class="w-full sm:w-auto p-3 bg-white dark:bg-slate-800 text-slate-500 dark:text-slate-400 rounded-xl shadow-sm border border-slate-200 dark:border-slate-700 hover:text-amber-500 dark:hover:text-amber-400 hover:shadow-md transition-all active:scale-95 flex items-center justify-center"
                title="รีเฟรชข้อมูล">
                <span class="material-icons">refresh</span>
            </button>
        </div>
    </div>

    <!-- Collapsible Dashboard Section -->
    <div class="overflow-hidden transition-all duration-500 ease-in-out"
        [style.max-height]="showDashboard ? '1000px' : '0'" [style.opacity]="showDashboard ? '1' : '0'"
        [style.margin-bottom]="showDashboard ? '2rem' : '0'">

        <!-- Stats Cards Grid (4 Columns) -->
        <div *ngIf="dashboardStats.length > 0" class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
            <div *ngFor="let stat of dashboardStats; let i = index"
                class="animate-fade-in bg-white dark:bg-slate-800 rounded-2xl p-6 shadow-[0_4px_20px_rgb(0,0,0,0.03)] border border-slate-100 dark:border-slate-700 hover:shadow-[0_8px_30px_rgb(0,0,0,0.06)] dark:hover:shadow-[0_8px_30px_rgba(0,0,0,0.2)] hover:-translate-y-1 transition-all duration-300 relative overflow-hidden group"
                [ngStyle]="{'animation-delay': (i * 0.05) + 's'}">

                <!-- Background Icon Decoration -->
                <div class="absolute -right-6 -top-6 w-32 h-32 rounded-full opacity-[0.08] dark:opacity-[0.04] transition-transform group-hover:scale-110"
                    [ngClass]="stat.color.split(' ')[0].replace('text-', 'bg-')"></div>

                <div class="relative z-10 flex justify-between items-start mb-4">
                    <div class="w-auto min-w-12 h-12 p-2 rounded-xl flex items-center justify-center shadow-sm"
                        [ngClass]="stat.color.replace('text-', 'bg-').replace('600', '50').replace('500', '50') + ' ' + stat.color">
                        <span class="material-icons text-2xl">{{ stat.icon }}</span>
                    </div>
                </div>

                <div class="relative z-10">
                    <h4
                        class="text-slate-400 dark:text-slate-500 text-xs font-bold uppercase tracking-wider mb-1 truncate">
                        {{ stat.title }}
                    </h4>
                    <h4 *ngIf="stat.subtitle"
                        class="text-slate-400 dark:text-slate-500 opacity-60 text-xs font uppercase tracking-wider mb-1 truncate">
                        {{
                        stat.subtitle }}
                    </h4>
                    <div class="text-2xl font-black text-slate-800 dark:text-white tracking-tight">{{ stat.value }}
                    </div>
                </div>
            </div>
        </div>

        <div class="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-8">
            <!-- Chart Section -->
            <div class="animate-fade-in lg:col-span-2 bg-white dark:bg-slate-800 rounded-2xl shadow-sm border border-gray-100 dark:border-slate-700 p-6 pb-10 relative overflow-hidden"
                style="animation-delay: 0.25s;">
                <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 gap-4">
                    <div>
                        <h3 class="text-xl font-bold text-slate-800 dark:text-white">
                            แนวโน้มรายได้
                            <span
                                class="text-sm font-medium text-slate-500 dark:text-slate-400 ml-2 bg-slate-100 dark:bg-slate-700 px-2 py-0.5 rounded-full">
                                {{ chartTotalCount }} รายการ
                            </span>
                        </h3>
                        <div class="flex items-center gap-4 text-xs font-medium mt-1">
                            <span class="flex items-center gap-1 "><span
                                    class="w-2 h-2 rounded-full bg-amber-400"></span>
                                <span class="text-slate-600 dark:text-slate-300">{{ chartMode === 'daily' ? 'รายวัน' :
                                    'รายเดือน' }}</span>
                                <span class="text-slate-400 dark:text-slate-500">
                                    @if(chartMode === 'daily' && dailySubMode === 'default') {
                                    ( 7 วันย้อนหลัง )
                                    }
                                    @if(chartMode === 'daily' && dailySubMode === 'custom') {
                                    ( สูงสุด 10 วัน)
                                    }
                                    @if(chartMode === 'monthly') {
                                    ( {{ selectedMonthStart | date: 'MM/yyyy' }} - {{ selectedMonthEnd | date: 'MM/yyyy'
                                    }}
                                    )
                                    } </span>
                            </span>
                        </div>
                    </div>

                    <!-- Chart Controls -->
                    <div class="flex flex-col items-end gap-2">

                        <!-- Row 1: Inputs & Sub-Modes -->
                        <div class="flex items-center gap-2 min-h-[34px]">

                            <!-- Daily Controls -->
                            <div *ngIf="chartMode === 'daily'" class="flex items-center gap-2">
                                <div
                                    class="flex bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700/50 rounded-lg p-0.5 gap-1">
                                    <button (click)="setDailySubMode('default')"
                                        class="px-2 py-1 text-xs font-medium rounded-md transition-all"
                                        [ngClass]="dailySubMode === 'default' ? 'bg-white dark:bg-slate-700 text-slate-800 dark:text-white shadow-sm' : 'text-slate-400 dark:text-slate-500 hover:text-slate-600 dark:hover:text-slate-300'">
                                        ทั้งหมด
                                    </button>
                                    <button (click)="setDailySubMode('custom')"
                                        class="px-2 py-1 text-xs font-medium rounded-md transition-all"
                                        [ngClass]="dailySubMode === 'custom' ? 'bg-white dark:bg-slate-700 text-slate-800 dark:text-white shadow-sm' : 'text-slate-400 dark:text-slate-500 hover:text-slate-600 dark:hover:text-slate-300'">
                                        กำหนดเอง
                                    </button>
                                </div>

                                <div *ngIf="dailySubMode === 'custom'"
                                    class="flex items-center bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700/50 rounded-lg px-2 py-1">
                                    <input type="date" [(ngModel)]="customStartDate" (change)="onCustomDateChange()"
                                        [max]="customEndDate"
                                        class="bg-transparent border-none text-xs text-slate-600 dark:text-slate-300 font-medium focus:ring-0 p-0 w-24">
                                    <span class="mx-1 text-slate-300 dark:text-slate-600">-</span>
                                    <input type="date" [(ngModel)]="customEndDate" (change)="onCustomDateChange()"
                                        [min]="customStartDate" [max]="maxCustomDate"
                                        class="bg-transparent border-none text-xs text-slate-600 dark:text-slate-300 font-medium focus:ring-0 p-0 w-24">

                                    <button (click)="resetCustomDate()"
                                        class="ml-2 w-5 h-5 flex items-center justify-center rounded-full hover:bg-slate-100 dark:hover:bg-slate-700 text-slate-400 dark:text-slate-500 hover:text-amber-500 dark:hover:text-amber-400 transition-colors"
                                        title="รีเซ็ตเป็น 10 วันล่าสุด">
                                        <span class="material-icons text-[16px]">refresh</span>
                                    </button>
                                </div>
                            </div>

                            <!-- Monthly Inputs -->
                            <div *ngIf="chartMode === 'monthly'"
                                class="flex items-center gap-2 bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700/50 rounded-lg px-2 py-1">
                                <input type="month" [(ngModel)]="selectedMonthStart" (change)="onChartMonthChange()"
                                    class="bg-transparent border-none text-xs font-bold text-slate-600 dark:text-slate-300 p-0 focus:ring-0 outline-none w-[110px]">
                                <span class="text-slate-300 dark:text-slate-600 mx-1">-</span>
                                <input type="month" [(ngModel)]="selectedMonthEnd" (change)="onChartMonthChange()"
                                    class="bg-transparent border-none text-xs font-bold text-slate-600 dark:text-slate-300 p-0 focus:ring-0 outline-none w-[110px]">
                            </div>

                        </div>

                        <!-- Row 2: Toggles -->
                        <div class="flex items-center gap-2">
                            <!-- Type Toggle -->
                            <div class="flex bg-slate-100 dark:bg-slate-900/50 p-1 rounded-lg">
                                <button (click)="setChartType('line')"
                                    [class]="chartType === 'line' ? 'bg-white dark:bg-slate-700 text-slate-800 dark:text-white shadow-sm' : 'text-slate-500 dark:text-slate-400 hover:text-slate-700 dark:hover:text-slate-300'"
                                    class="p-1 px-2 rounded-md transition-all" title="Line Chart">
                                    <span class="material-icons text-sm">show_chart</span>
                                </button>
                                <button (click)="setChartType('bar')"
                                    [class]="chartType === 'bar' ? 'bg-white dark:bg-slate-700 text-slate-800 dark:text-white shadow-sm' : 'text-slate-500 dark:text-slate-400 hover:text-slate-700 dark:hover:text-slate-300'"
                                    class="p-1 px-2 rounded-md transition-all" title="Bar Chart">
                                    <span class="material-icons text-sm">bar_chart</span>
                                </button>
                            </div>

                            <!-- Mode Toggle -->
                            <div class="flex bg-slate-100 dark:bg-slate-900/50 p-1 rounded-lg">
                                <button (click)="setChartMode('daily')"
                                    [class]="chartMode === 'daily' ? 'bg-white dark:bg-slate-700 text-slate-800 dark:text-white shadow-sm' : 'text-slate-500 dark:text-slate-400 hover:text-slate-700 dark:hover:text-slate-300'"
                                    class="px-3 py-1 text-xs font-bold rounded-md transition-all">รายวัน</button>
                                <button (click)="setChartMode('monthly')"
                                    [class]="chartMode === 'monthly' ? 'bg-white dark:bg-slate-700 text-slate-800 dark:text-white shadow-sm' : 'text-slate-500 dark:text-slate-400 hover:text-slate-700 dark:hover:text-slate-300'"
                                    class="px-3 py-1 text-xs font-bold rounded-md transition-all">รายเดือน</button>
                            </div>
                        </div>

                    </div>
                </div>

                <div class="relative h-64 w-full">
                    <svg viewBox="0 0 100 100" class="w-full h-full overflow-visible" preserveAspectRatio="none">
                        <defs>
                            <linearGradient id="gradientArea" x1="0" x2="0" y1="0" y2="1">
                                <stop offset="0%" stop-color="#fbbf24" stop-opacity="0.4" />
                                <stop offset="100%" stop-color="#fbbf24" stop-opacity="0" />
                            </linearGradient>
                        </defs>

                        <!-- Grid Lines -->
                        <g class="text-slate-200 dark:text-slate-700/50">
                            <line x1="0" y1="100" x2="100" y2="100" stroke="currentColor" stroke-width="0.5" />
                            <line x1="0" y1="75" x2="100" y2="75" stroke="currentColor" stroke-width="0.5"
                                stroke-dasharray="2" />
                            <line x1="0" y1="50" x2="100" y2="50" stroke="currentColor" stroke-width="0.5"
                                stroke-dasharray="2" />
                            <line x1="0" y1="25" x2="100" y2="25" stroke="currentColor" stroke-width="0.5"
                                stroke-dasharray="2" />
                            <line x1="0" y1="0" x2="100" y2="0" stroke="currentColor" stroke-width="0.5"
                                stroke-dasharray="2" />
                        </g>

                        <!-- Line Chart -->
                        <g *ngIf="chartType === 'line'">
                            <polygon [attr.points]="currentMonthAreaPoints" fill="url(#gradientArea)"
                                class="opacity-50 transition-all duration-500" />
                            <polyline [attr.points]="currentMonthPoints" fill="none" stroke="#fbbf24" stroke-width="0.5"
                                stroke-linecap="round" stroke-linejoin="round"
                                class="drop-shadow-sm transition-all duration-500" />

                            <!-- Dots (Hover effect) -->
                            <circle *ngFor="let point of currentMonthDots" [attr.cx]="point.x" [attr.cy]="point.y"
                                r="1.5" fill="#fff" stroke="#fbbf24" stroke-width="1"
                                class="opacity-0 hover:opacity-100 transition-opacity cursor-pointer">
                                <title>{{ point.label }}: {{ point.value }}</title>
                            </circle>
                        </g>

                        <!-- Bar Chart -->
                        <g *ngIf="chartType === 'bar'">
                            <rect *ngFor="let point of currentMonthDots" [attr.x]="point.x - 2" [attr.y]="point.y"
                                width="4" [attr.height]="100 - point.y" [attr.fill]="point.color"
                                class="hover:opacity-80 hover:fill-yellow-500 border-2 border-white transition-all duration-300 cursor-pointer rx-[1px]">
                                <title>{{ point.label }}: {{ point.value }}</title>
                            </rect>
                        </g>
                    </svg>

                    <!-- Y-Axis Labels (Left Side) -->
                    <div
                        class="absolute inset-y-0 left-[-30px] bottom-2 w-8 flex flex-col justify-between text-[9px] text-yellow-400 font-medium pointer-events-none py-0 items-end pr-1">
                        <span>{{ yAxisLabels[4] }}</span>
                        <span>{{ yAxisLabels[3] }}</span>
                        <span>{{ yAxisLabels[2] }}</span>
                        <span>{{ yAxisLabels[1] }}</span>
                        <span class="translate-y-2">{{ yAxisLabels[0] }}</span>
                    </div>

                    <!-- Dynamic Labels -->
                    <div class="absolute bottom-0 left-0 right-0 translate-y-8 h-8 pointer-events-none">
                        <ng-container *ngFor="let dot of currentMonthDots; let i = index">
                            <div *ngIf="(currentMonthDots.length <= 15) || (i % 5 === 0) || i === 0 || i === currentMonthDots.length - 1"
                                class="absolute top-0 flex flex-col items-center whitespace-nowrap"
                                [style.left.%]="dot.x" style="transform: translateX(-50%);">
                                <span class="text-[10px] text-slate-400 font-medium">{{ dot.label }}</span>
                                <span *ngIf="dot.subLabel" class="text-[9px] text-slate-400">{{ dot.subLabel }}</span>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>

            <!-- Recent Activity -->
            <div class="animate-fade-in lg:col-span-1 bg-white dark:bg-slate-800 rounded-3xl shadow-[0_4px_20px_rgb(0,0,0,0.03)] border border-slate-100 dark:border-slate-700 p-8"
                style="animation-delay: 0.3s;">
                <h3 class="text-xl font-bold text-slate-800 dark:text-white mb-6">รายการล่าสุด</h3>
                <div class="relative">
                    <div class="absolute left-5 top-4 bottom-4 w-0.5 bg-slate-100 dark:bg-slate-700"></div>
                    <div class="space-y-6 relative">
                        <div *ngFor="let item of recentActivity" class="flex items-start gap-4 group">
                            <div class="w-10 h-10 rounded-full flex-shrink-0 flex items-center justify-center text-white text-sm font-bold shadow-md ring-4 ring-white dark:ring-slate-800 z-10"
                                [ngClass]="item.color">
                                {{ item.initial }}
                            </div>
                            <div class="flex-1 pt-1">
                                <div class="flex justify-between items-start">
                                    <h5
                                        class="text-sm font-bold text-slate-800 dark:text-white group-hover:text-amber-500 transition-colors">
                                        {{ item.name }}</h5>
                                    <span
                                        class="text-[10px] font-semibold text-slate-400 dark:text-slate-500 bg-slate-50 dark:bg-slate-700 px-2 py-0.5 rounded-full border border-slate-100 dark:border-slate-600 whitespace-nowrap">{{
                                        item.timeAgo }}</span>
                                </div>
                                <p class="text-xs text-slate-500 dark:text-slate-400 mt-0.5">{{ item.info }}</p>
                            </div>
                        </div>
                        <div *ngIf="recentActivity.length === 0"
                            class="text-center text-slate-400 dark:text-slate-500 py-10">
                            <span class="material-icons text-3xl mb-2 opacity-50">history</span>
                            <p class="text-sm">ไม่มีกิจกรรมล่าสุด</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- End Collapsible Dashboard Section -->

    <div class="animate-fade-in bg-white dark:bg-slate-800 rounded-3xl shadow-[0_4px_20px_rgb(0,0,0,0.03)] border border-slate-100 dark:border-slate-700 overflow-hidden flex flex-col md:flex-row h-full min-h-[600px]  "
        style="animation-delay: 0.35s;">

        <!-- Sidebar Filter -->
        <div
            class="w-full md:w-64 border-r border-slate-100 dark:border-slate-700 p-6 bg-slate-50/50 dark:bg-slate-800/50 flex flex-col gap-6 shrink-0">

            <!-- Title -->
            <h3 class="text-lg font-bold text-slate-800 dark:text-white flex items-center gap-2 mb-2">
                <span class="material-icons text-amber-500">filter_alt</span> ตัวกรอง
            </h3>

            <!-- Min Fee Filter -->
            <div>
                <div class="flex items-center justify-between mb-3">
                    <h3 class="text-sm font-bold text-slate-800 dark:text-white flex items-center gap-2">
                        <span class="material-icons text-sm text-slate-400">attach_money</span> ขั้นต่ำ (Min Fee)
                    </h3>
                </div>
                <div class="relative w-full">
                    <span
                        class="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 dark:text-slate-500 font-bold text-xs">฿</span>
                    <input type="number" placeholder="จำนวนเงินขั้นต่ำ" [(ngModel)]="minFee"
                        (ngModelChange)="onMinFeeChange()"
                        class="w-full pl-7 pr-4 py-2 bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-700/50 rounded-lg text-sm font-medium text-slate-600 dark:text-slate-300 focus:ring-2 focus:ring-amber-200 focus:border-amber-400 transition-all placeholder:text-slate-400 dark:placeholder:text-slate-500 outline-none">
                </div>
            </div>

            <div class="w-full border-t border-slate-200 dark:border-slate-700"></div>

            <!-- Fee Type Filter -->
            <div>
                <div class="flex items-center justify-between mb-3">
                    <h3 class="text-sm font-bold text-slate-800 dark:text-white flex items-center gap-2">
                        <span class="material-icons text-sm text-slate-400">category</span> ประเภท (Type)
                    </h3>
                </div>
                <div class="flex flex-col gap-2">
                    <label *ngFor="let type of feeTypeOptions"
                        class="flex items-center gap-3 cursor-pointer group p-1.5 hover:bg-white dark:hover:bg-slate-700/50 rounded-lg transition-all border border-transparent hover:border-slate-100 dark:hover:border-slate-600">
                        <div class="relative flex items-center justify-center">
                            <input type="checkbox" [checked]="filterFeeType === type" (change)="toggleFeeType(type)"
                                class="peer appearance-none w-5 h-5 border-2 border-slate-300 dark:border-slate-600 rounded-md focus:ring-amber-400 checked:bg-amber-400 checked:border-amber-400 transition-all cursor-pointer">
                            <span
                                class="material-icons absolute text-white opacity-0 peer-checked:opacity-100 transition-opacity pointer-events-none"
                                style="font-size: 14px;">check</span>
                        </div>
                        <span class="text-sm text-slate-600 dark:text-slate-300 font-medium select-none">{{ type
                            }}</span>
                    </label>
                </div>
            </div>

            <div class="w-full border-t border-slate-200 dark:border-slate-700"></div>

            <div class="p-3 rounded-xl bg-amber-50/60 dark:bg-amber-500/10 border border-amber-100 dark:border-amber-500/20 text-xs text-amber-800 dark:text-amber-200">
                กรองตามลานที่เลือกใน Sidebar — เปลี่ยนลานจากแถบด้านข้างเพื่อดูข้อมูลลานอื่น
            </div>

            <div class="w-full border-t border-slate-200 dark:border-slate-700"></div>

            <!-- Fee Name Filter -->
            <div>
                <div class="flex items-center justify-between mb-3">
                    <h3 class="text-sm font-bold text-slate-800 dark:text-white flex items-center gap-2">
                        <span class="material-icons text-sm text-slate-400">label</span> รายการ (Fee)
                    </h3>
                    <button (click)="resetFeeNameFilter()" class="text-xs text-amber-500 hover:text-amber-600 underline"
                        *ngIf="feeNameSearchText || filterFeeName">
                        ล้างค่า
                    </button>
                </div>

                <!-- Fee Name Search -->
                <div class="mb-3 relative group">
                    <input type="text" [(ngModel)]="feeNameSearchText" placeholder="ค้นหารายการ..."
                        class="w-full pl-8 pr-3 py-1.5 text-sm bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-700/50 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-100 focus:border-amber-400 transition-all text-slate-600 dark:text-slate-300 placeholder:text-slate-400 dark:placeholder:text-slate-500">
                    <span
                        class="material-icons absolute left-2 top-2 text-slate-400 text-[18px] group-focus-within:text-amber-500 transition-colors">search</span>
                </div>

                <div class="flex flex-col gap-2 max-h-[200px] overflow-y-auto custom-scrollbar pr-2">
                    <label *ngFor="let name of filteredFeeNameOptions"
                        class="flex items-center gap-3 cursor-pointer group p-1.5 hover:bg-white dark:hover:bg-slate-700/50 rounded-lg transition-all block border border-transparent hover:border-slate-100 dark:hover:border-slate-600">
                        <div class="relative flex items-center justify-center shrink-0">
                            <input type="checkbox" [checked]="filterFeeName === name" (change)="toggleFeeName(name)"
                                class="peer appearance-none w-5 h-5 border-2 border-slate-300 dark:border-slate-600 rounded-md focus:ring-amber-400 checked:bg-amber-400 checked:border-amber-400 transition-all cursor-pointer">
                            <span
                                class="material-icons absolute text-white opacity-0 peer-checked:opacity-100 transition-opacity pointer-events-none"
                                style="font-size: 14px;">check</span>
                        </div>
                        <span class="text-sm text-slate-600 dark:text-slate-300 font-medium truncate select-none"
                            [title]="name">{{ name
                            }}</span>
                    </label>
                    <div *ngIf="filteredFeeNameOptions.length === 0"
                        class="text-xs text-slate-400 italic p-2 text-center">
                        ไม่พบข้อมูลรายการ</div>
                </div>
            </div>



        </div>

        <!-- Main Content -->
        <div
            class="flex-1 flex flex-col min-w-0 bg-white dark:bg-slate-900 border-l border-slate-100 dark:border-slate-700/50">

            <!-- Table Toolbar -->
            <div
                class="p-4 border-b border-slate-100 dark:border-slate-700/50 flex flex-col sm:flex-row sm:items-center justify-between gap-4">
                <div class="text-sm font-bold text-slate-700 dark:text-slate-200 hidden sm:block">
                    <div class="flex items-center gap-2">
                        <h3 class="text-lg font-bold text-slate-800 dark:text-white flex items-center gap-2">
                            <span class="material-icons text-amber-500">payments</span>
                            รายการรายได้
                        </h3>
                        <span class="text-slate-400 dark:text-slate-500 font-normal">({{ totalItems | number }})</span>
                    </div>
                </div>

                <!-- Search Bar -->
                <div
                    class="flex items-center bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-50 dark:border-slate-700/50 focus-within:bg-white dark:focus-within:bg-slate-900 focus-within:ring-2 focus-within:ring-amber-200 transition-all overflow-visible w-full md:w-[320px] relative z-30 ml-auto">

                    <!-- Search Type Dropdown -->
                    <div class="relative min-w-[140px] border-r border-slate-200 dark:border-slate-700/50">
                        <button (click)="toggleSearchTypeDropdown()"
                            class="w-full pl-4 pr-3 py-2.5 text-sm font-bold text-slate-600 dark:text-slate-300 flex items-center justify-between hover:text-amber-600 dark:hover:text-amber-500 hover:bg-slate-100 dark:hover:bg-slate-700/50 rounded-l-xl transition-all focus:outline-none h-full">
                            <span class="truncate">{{ currentSearchTypeLabel }}</span>
                            <span
                                class="material-icons text-sm text-slate-400 dark:text-slate-500 transition-transform duration-200"
                                [ngClass]="{'rotate-180': isSearchTypeDropdownOpen}">expand_more</span>
                        </button>

                        <!-- Backdrop -->
                        <button *ngIf="isSearchTypeDropdownOpen" class="fixed inset-0 cursor-default z-40"
                            (click)="toggleSearchTypeDropdown()"></button>

                        <!-- Dropdown Menu -->
                        <div *ngIf="isSearchTypeDropdownOpen"
                            class="absolute top-full mt-2 left-0 w-[160px] bg-white dark:bg-slate-800 rounded-xl shadow-xl border border-slate-100 dark:border-slate-700 py-1 z-50 overflow-hidden animation-fade-in-up">
                            <button (click)="selectSearchType('all')"
                                class="w-full text-left px-4 py-2.5 text-sm font-medium text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700/50 hover:text-amber-500 transition-colors flex items-center gap-2">
                                <span class="material-icons text-lg text-slate-400 dark:text-slate-500">search</span>
                                ค้นหาทั่วไป
                            </button>
                            <button (click)="selectSearchType('receiptId')"
                                class="w-full text-left px-4 py-2.5 text-sm font-medium text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700/50 hover:text-amber-500 transition-colors flex items-center gap-2">
                                <span class="material-icons text-lg text-slate-400 dark:text-slate-500">receipt</span>
                                เลขที่ใบเสร็จ
                            </button>
                            <button (click)="selectSearchType('feeName')"
                                class="w-full text-left px-4 py-2.5 text-sm font-medium text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700/50 hover:text-amber-500 transition-colors flex items-center gap-2">
                                <span class="material-icons text-lg text-slate-400 dark:text-slate-500">label</span>
                                รายการรายได้
                            </button>
                            <button (click)="selectSearchType('description')"
                                class="w-full text-left px-4 py-2.5 text-sm font-medium text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700/50 hover:text-amber-500 transition-colors flex items-center gap-2">
                                <span
                                    class="material-icons text-lg text-slate-400 dark:text-slate-500">description</span>
                                หมายเหตุ
                            </button>
                        </div>
                    </div>

                    <div class="relative flex-1">
                        <span
                            class="absolute left-3 top-1/2 -translate-y-1/2 material-icons text-slate-400 dark:text-slate-500 text-xl">search</span>
                        <input type="text"
                            [placeholder]="searchType === 'receiptId' ? 'ค้นหาเลขที่ใบเสร็จ...' : (searchType === 'feeName' ? 'ค้นหารายการรายได้...' : 'ค้นหา...')"
                            [(ngModel)]="searchText" (keyup.enter)="onClickSearch()"
                            class="w-full pl-10 pr-4 py-2.5 bg-transparent border-none text-sm font-medium text-slate-600 dark:text-slate-300 focus:ring-0 focus:outline-none placeholder:text-slate-400 dark:placeholder:text-slate-500 rounded-r-xl h-[46px]">
                    </div>
                    <button type="button" (click)="onClickSearch()"
                        class="px-3 py-2 mr-1 text-xs font-bold bg-amber-400 text-white rounded-lg">ค้นหา</button>
                </div>
            </div>

            <div class="flex-1 overflow-x-auto overflow-y-auto custom-scrollbar relative">
                <table class="w-full text-left border-collapse">
                    <thead class="sticky top-0 z-20 bg-white/95 dark:bg-slate-900/95 backdrop-blur-sm shadow-sm">
                        <tr>
                            <th class="p-5 text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider whitespace-nowrap">
                                เลขที่ใบเสร็จ
                            </th>

                            <th class="p-5 text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider whitespace-nowrap">
                                รายการรายได้
                            </th>

                            <th class="p-5 text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider whitespace-nowrap">
                                สถานที่
                            </th>

                            <th class="p-5 text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider whitespace-nowrap">
                                ประเภท
                            </th>

                            <th class="p-5 text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider whitespace-nowrap text-right">
                                จำนวนเงิน
                            </th>

                            <th class="p-5 text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider whitespace-nowrap">
                                วันที่ชำระ
                            </th>

                            <th class="p-5 text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider whitespace-nowrap text-center w-16">
                            </th>
                        </tr>
                    </thead>

                    <tbody class="divide-y divide-slate-50 dark:divide-slate-800/50">
                        <tr *ngFor="let c of revenues; let i = index"
                            class="animate-table-row group hover:bg-amber-50/40 dark:hover:bg-slate-800/50 transition-colors duration-200 cursor-pointer"
                            [ngStyle]="{'animation-delay': (i * 0.03) + 's'}"
                            (click)="openDetailModal(c.id)">

                            <td
                                class="p-5 text-sm font-bold text-slate-700 dark:text-slate-300 group-hover:text-amber-600 dark:group-hover:text-amber-400 transition-colors whitespace-nowrap">
                                {{ c.receiptId || '-' }}
                            </td>

                            <td class="p-5 padding-y-4">
                                <div class="flex flex-col">
                                    <span class="text-sm font-bold text-slate-700 dark:text-slate-300">{{ c.feeName ||
                                        '-' }}</span>
                                    <span class="text-xs text-slate-400 dark:text-slate-500 truncate max-w-xs">{{
                                        c.description }}</span>
                                </div>
                            </td>

                            <td class="p-5 whitespace-nowrap">
                                <div class="flex items-center gap-3">
                                    <div
                                        class="flex-shrink-0 w-8 h-8 rounded-full bg-slate-100 dark:bg-slate-800 flex items-center justify-center text-slate-500 dark:text-slate-400 font-bold text-xs shadow-sm group-hover:bg-white dark:group-hover:bg-slate-700 group-hover:text-amber-500 transition-colors">
                                        {{ c.siteName ? c.siteName.charAt(0) : '?' }}
                                    </div>
                                    <span class="text-sm font-bold text-slate-700 dark:text-slate-300">{{ c.siteName ||
                                        '-' }}</span>
                                </div>
                            </td>

                            <td class="p-5 text-center">
                                <span
                                    class="inline-flex items-center justify-center gap-1.5 px-2.5 py-1 text-xs font-bold rounded-lg border shadow-sm bg-slate-50 dark:bg-slate-800 text-slate-600 dark:text-slate-300 border-slate-200 dark:border-slate-700/50">
                                    <span *ngIf="c.feeType === 'เงินสด'"
                                        class="material-icons text-[12px] text-emerald-500">payments</span>
                                    <span *ngIf="c.feeType === 'โอนเงินผ่านธนาคาร'"
                                        class="material-icons text-[12px] text-blue-500">account_balance</span>
                                    {{ c.feeType || '-' }}
                                </span>
                            </td>

                            <td class="p-5 text-right font-bold text-slate-700 dark:text-slate-300">
                                {{ (c.fee | number:'1.2-2') || '0.00' }}
                            </td>

                            <td
                                class="p-5 whitespace-nowrap text-sm text-slate-500 dark:text-slate-400 font-medium text-center">
                                {{ c.paidDate | date:'dd/MM/yyyy HH:mm' }}
                            </td>

                            <td class="p-5 text-center">
                                <button (click)="$event.stopPropagation(); openDetailModal(c.id)"
                                    class="inline-flex items-center justify-center w-9 h-9 rounded-xl border border-slate-200 dark:border-slate-700 text-slate-400 hover:text-amber-600 hover:border-amber-300 dark:hover:border-amber-700 transition-colors"
                                    title="ดูรายละเอียด">
                                    <span class="material-icons text-[18px]">visibility</span>
                                </button>
                            </td>
                        </tr>

                        <tr *ngIf="!isLoading && revenues.length === 0">
                            <td [attr.colspan]="7" class="py-20 text-center">
                                <div class="flex flex-col items-center justify-center">
                                    <div
                                        class="w-16 h-16 bg-slate-50 dark:bg-slate-800/50 rounded-full flex items-center justify-center mb-3">
                                        <span
                                            class="material-icons text-3xl text-slate-300 dark:text-slate-600">search_off</span>
                                    </div>
                                    <h3 class="text-slate-800 dark:text-white font-bold">ไม่พบข้อมูล</h3>
                                    <span
                                        class="text-slate-400 dark:text-slate-500 text-sm mt-1">ลองปรับตัวกรองหรือค้นหาใหม่อีกครั้ง</span>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- Pagination Footer -->
            <div
                class="px-6 py-4 border-t border-slate-100 dark:border-slate-700/50 bg-white dark:bg-slate-900 flex flex-col md:flex-row items-center justify-between gap-4 w-full">
                <div class="flex items-center gap-4 text-sm text-slate-500 dark:text-slate-400 font-medium">
                    <span>แสดง {{ startItemIndex | number }} - {{ endItemIndex | number }} จาก {{ totalItems | number }}
                        รายการ</span>
                    <select (change)="onPageSizeChange($event)" [(ngModel)]="pageSize"
                        class="bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700/50 text-slate-700 dark:text-slate-300 text-sm rounded-lg focus:ring-2 focus:ring-amber-100 focus:border-amber-400 block p-1.5 pr-8 font-bold outline-none cursor-pointer hover:bg-white dark:hover:bg-slate-700/50 transition-colors">
                        <option *ngFor="let size of pageSizeOptions" [value]="size">{{ size }} / หน้า</option>
                    </select>
                </div>

                <div class="flex items-center gap-2">
                    <button (click)="setPage(currentPage - 1)" [disabled]="currentPage === 1"
                        class="w-9 h-9 flex items-center justify-center rounded-lg border border-slate-200 dark:border-slate-700/50 hover:bg-slate-50 dark:hover:bg-slate-800 hover:text-amber-500 dark:hover:text-amber-400 disabled:opacity-30 disabled:cursor-not-allowed transition-all text-slate-500 dark:text-slate-400">
                        <span class="material-icons text-sm">chevron_left</span>
                    </button>

                    <button *ngFor="let page of pagesArray" (click)="setPage(page)"
                        class="w-9 h-9 flex items-center justify-center rounded-lg text-sm font-bold transition-all"
                        [ngClass]="page === currentPage ? 'bg-amber-400 text-white shadow-lg shadow-amber-200 dark:shadow-amber-900/20' : 'text-slate-600 dark:text-slate-400 hover:bg-amber-50 dark:hover:bg-slate-800 hover:text-amber-600 dark:hover:text-amber-400'">
                        {{ page }}
                    </button>

                    <button (click)="setPage(currentPage + 1)"
                        [disabled]="currentPage === totalPages || totalPages === 0"
                        class="w-9 h-9 flex items-center justify-center rounded-lg border border-slate-200 hover:bg-slate-50 hover:text-amber-500 disabled:opacity-30 disabled:cursor-not-allowed transition-all text-slate-500">
                        <span class="material-icons text-sm">chevron_right</span>
                    </button>
                </div>
            </div>

        </div>
    </div>
</div>

<app-pss-loading *ngIf="isLoading && !isFormView"></app-pss-loading>

<app-revenue-add-form *ngIf="isFormView" [siteId]="selectedSiteId" [menuId]="menuId" (cancel)="backToList()" (saved)="onFormSaved()"></app-revenue-add-form>

<app-modal-revenue-detail
  *ngIf="isDetailModalOpen"
  [financeId]="selectedRevenueId"
  [siteId]="selectedSiteId"
  [userId]="userId"
  (close)="closeDetailModal()">
</app-modal-revenue-detail>